import { useEffect, useReducer, useRef, useState } from 'react';

function reducer(currentState, newState) {
    return { ...currentState, ...newState };
}

export default function Clock(props: { deadline: string; alreadyJoined: boolean; alreadyPaid: boolean }): JSX.Element {
    const { deadline, alreadyJoined, alreadyPaid } = props;
    const [state, setState] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    });
    const sepate = ':';
    const [{ running, lapse }, setStateLapse] = useReducer(reducer, {
        running: false,
        lapse: 0,
    });
    const intervalRef = useRef(null);

    useEffect(() => {
        //getTimeUntil(deadline);
        setInterval(() => getTimeUntil(deadline), 1000);
        clearInterval(intervalRef.current);
    }, []);

    const startMilSeg = () => {
        if (running) {
            clearInterval(intervalRef.current);
        } else {
            const startTime = Date.now() - lapse;
            intervalRef.current = setInterval(() => {
                setStateLapse({ lapse: Date.now() - startTime });
            }, 0);
        }
        setStateLapse({ running: !running });
    };

    const leading0 = (num: string | number) => {
        return num < 10 ? '0' + num : num;
    };
    const getTimeUntil = (deadline: string) => {
        //const time = Date.parse(deadline) - Date.parse(new Date());
        const mydate = new Date();

        const time: number = Date.parse(deadline) - Date.parse(mydate.toString());
        if (time < 0) {
            setState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        } else {
            const seconds = Math.floor((time / 1000) % 60);
            const minutes = Math.floor((time / 1000 / 60) % 60);
            const hours = Math.floor((time / (1000 * 60 * 60)) % 24);
            const days = Math.floor(time / (1000 * 60 * 60 * 24));
            startMilSeg();
            setState({ days, hours, minutes, seconds });
        }
    };
    return (
        <div
            className={`pt-8 grid w-full grid-cols-9 sm:grid-cols-9 text-center justify-between font-bold italic text-sm-blue-primary relative group`}
        >
            {state.days > 0 || state.hours > 0 || state.minutes > 0 || state.seconds > 0 ? (
                <>
                    <div className="">{leading0(state.days)}</div>
                    <div className="">{sepate}</div>
                    <div className="">{leading0(state.hours)}</div>
                    <div className="">{sepate}</div>
                    <div className="">{leading0(state.minutes)}</div>
                    <div className="">{sepate}</div>
                    <div className="">{leading0(state.seconds)}</div>
                    <div className="">{sepate}</div>
                    <div className="">{lapse.toString().slice(-2)}</div>
                    <div className="">D</div>
                    <div className=""></div>
                    <div className="">H</div>
                    <div className=""></div>
                    <div className="">M</div>
                    <div className=""></div>
                    <div className="">S</div>
                    <div className=""></div>
                    <div className=""></div>
                    <div className="absolute bottom-0 flex-col items-center hidden mb-14 group-hover:flex">
                        <span className="relative z-10 p-2 text-xs leading-none text-white whitespace-no-wrap bg-sm-blue-primary  shadow-lg rounded-md ">
                            {alreadyJoined
                                ? alreadyPaid
                                    ? 'Tiempo restante para iniciar el partido'
                                    : 'Tiempo restante para realizar el pago'
                                : 'Tiempo restante para poder inscribirse en la nómina.'}
                        </span>
                        <div className="w-3 h-3 -mt-2 rotate-45 bg-sm-blue-primary"></div>
                    </div>
                </>
            ) : (
                ''
            )}
        </div>
    );
}
